import { createAction, createSlice } from "@reduxjs/toolkit";
import { Document } from "../../@types/document";
import { Category } from "../../@types/Category";
import { Status } from "../../@types/status";
import { fetchDocuments } from "./actions/fetchDocuments";
import { fetchReportData } from "./actions/fetchReportData";

interface DocumentsListState {
  documents: Document[];
  searchText: string;
  page: number;
  sort: string;
  statusFilter?: Status[];
  createdAtFilter?: {
    from: number;
    to: number;
  };
  typeFilter?: Category[];
  viewMode: string;
  //
  findStatus: string;
  showFilterByStatusModal: boolean;
  showFilterByDateModal: boolean;
  count: number;
  showFilterByTypeModal: boolean;
  // Pending report
  showReportModal: boolean;
  fetchReportStatus: string;
  report: any[];
}

const initialState = {
  documents: [],
  searchText: "",
  page: 1,
  sort: "createdAt DESC",
  statusFilter: [],
  typeFilter: [],
  createdAtFilter: {
    from: 0,
    to: 0,
  },
  viewMode: "grid",
  //
  findStatus: "",
  showFilterByStatusModal: false,
  showFilterByDateModal: false,
  count: 0,
  showFilterByTypeModal: false,
  showReportModal: false,
  fetchReportStatus: "",
  report: [],
} as DocumentsListState;

// Mutaciones sincrónicas de datos
export const setSearchText = createAction<string>("SET_SEARCH_TEXT");
export const incrementPage = createAction("INCREMENT_PAGE");
export const resetDocumentList = createAction("RESET_DOCUMENT_LIST");
export const setSort = createAction<string>("SET_SORT");
export const setStatusFilter = createAction<any>("SET_STATUS_FILTER");
export const setTypeFilter = createAction<any>("SET_TYPE_FILTER");
export const setCreatedAtFilter = createAction<any>("SET_CREATED_AT_FILTER");
export const setViewMode = createAction<string>("SET_VIEW_MODE");
export const setFilterByStatusModal = createAction<boolean>("SET_FILTER_BY_STATUS_MODAL");
export const setFilterByDateModal = createAction<boolean>("SET_FILTER_BY_DATE_MODAL");
export const setFilterByTypeModal = createAction<boolean>("SET_FILTER_BY_TYPE_MODAL");
export const setShowReportModal = createAction<boolean>("SET_SHOW_REPORT_MODAL");

const documentsListSlice = createSlice({
  name: "documentsList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetDocumentList, (state) => {
        state.documents = [];
        state.page = 1;
      })
      .addCase(setViewMode, (state, { payload }) => {
        state.viewMode = payload;
      })
      .addCase(incrementPage, (state) => {
        state.page += 1;
      })
      // Buscar documentos
      .addCase(fetchDocuments.pending, (state) => {
        state.findStatus = "pending";
      })

      .addCase(fetchDocuments.fulfilled, (state, { payload }) => {
        if (payload.length > 1) {
          state.count = payload[1];
        }
        state.documents.push(...payload[0]);
        state.findStatus = "fulfilled";
      })
      .addCase(fetchDocuments.rejected, (state) => {
        state.findStatus = "rejected";
      })
      .addCase(setSearchText, (state, { payload = "" }) => {
        state.searchText = payload;
        state.page = 1;
        state.documents = [];
      })
      .addCase(setSort, (state, { payload }) => {
        state.sort = payload;
        state.page = 1;
        state.documents = [];
      })
      .addCase(setStatusFilter, (state, { payload }) => {
        state.statusFilter = payload;
        state.page = 1;
        state.documents = [];
      })
      .addCase(setCreatedAtFilter, (state, { payload }) => {
        state.createdAtFilter = payload;
        state.page = 1;
        state.documents = [];
      })
      .addCase(setTypeFilter, (state, { payload }) => {
        state.typeFilter = payload;
        state.page = 1;
        state.documents = [];
      })
      .addCase(setFilterByDateModal, (state, { payload }) => {
        state.showFilterByDateModal = payload;
      })
      .addCase(setFilterByStatusModal, (state, { payload }) => {
        state.showFilterByStatusModal = payload;
      })
      .addCase(setFilterByTypeModal, (state, { payload }) => {
        state.showFilterByTypeModal = payload;
      })
      .addCase(setShowReportModal, (state, { payload }) => {
        state.showReportModal = payload;
      })
      .addCase(fetchReportData.pending, (state, { payload }) => {
        state.showReportModal = true;
        state.fetchReportStatus = "pending";
      })
      .addCase(fetchReportData.fulfilled, (state, { payload }) => {
        state.fetchReportStatus = "fulfilled";
        state.report = payload;
      });
  },
});

export const documentsList = documentsListSlice.reducer;
